
module.exports = function(angularModule) {
  angularModule.service('contactDetailModal', function($uibModal, locationService) {

    this.open = function(contact) {
      $uibModal.open({
        controller: ['$scope','$uibModalInstance', function($scope, $uibModalInstance) {
          var vm = this;
          vm.contact = contact;
          vm.loading = false;

          vm.responded = 'No';
          if (contact.contactLog){
            vm.responded = _.findWhere(contact.contactLog, {type:"reviewSubmitted"}) ? 'Yes' : 'No';
          }

          if (vm.contact.locationId) {
            locationService.getLocation(vm.contact.locationId).then(function(res) {
              vm.location = res.businessName + " " + res.businessAddress.street + ", " + res.businessAddress.state
            });
          }

          vm.translateEventType = translateEventType;

          vm.hasCompletedEvent = function(){
            _.each(vm.contact.events,function(item){
              if(item.processingCompleted){
                return true;
              }
            });
            return false;
          }
        }],
        controllerAs: "vm",
        template: require("./contactDetailModal.html")
      });
    };

  });
};

function translateEventType(type) {
  var split = type.replace(/[A-Z]/, ' $&');
  return split.substring(0, 1).toUpperCase() + split.substring(1);
}
